<template>
  <div class="d-flex justify-content-between">
    <div class="card-body2">
      <div class="header-wizard" />
      <div class="body-wizard">
        <h3>Начало работы</h3>
        <hr>
        <h4>
          Дополнительные шаги - начните зарабатывать с помощью Домотеки уже сейчас!
          Хотите продолжить?
        </h4>
        <div class="d-flex justify-content-start">
          <router-link to="/app/end_wizard">
            <b-button variant="primary" style="margin-right: 1rem">
              Нет
            </b-button>
          </router-link>
          <b-button variant="primary" style="margin-left: 1rem" @click="checkPersonalAccountId">
            Да
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdditionalSteps',
  methods: {
    checkPersonalAccountId () {
      if (localStorage.getItem('personalAccId')) {
        this.$router.push('/app/accruals_form_wizard')
      } else this.$router.push('/app/attach_modules_wizard')
    }
  }
}
</script>

<style lang="scss" scoped>
@import './src/assets/scss/wizard';
</style>
